import React from 'react';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/es';
import { Button } from '../EntityList';
import CalendarEventRow from './CalendarEventRow';
import { groupEventsByCategory } from './calendarEventTypes';

/**
 * `.cal-detail` side panel — the month view's day-detail pane, replacing
 * CalendarDayModal for month view only (week/day keep the modal). Shows the
 * selected day's events grouped into `.cal-cat` cards by category, reusing
 * CalendarEventRow for the per-event content/actions.
 */
function CalendarDetailPanel({ day, events, onEditGoogleEvent, onDeleteGoogleEvent, onEditAppEvent, onAddEvent, googleConnected }) {
	const navigate = useNavigate();
	const categories = groupEventsByCategory(events || []);

	const handleEventClick = (event) => {
		if (event.externalLink) {
			window.open(event.externalLink, '_blank', 'noopener');
		} else if (event.link) {
			navigate(event.link);
		}
	};

	return (
		<section className='tw:bg-surface-2 tw:border tw:border-border tw:rounded-panel tw:flex tw:flex-col tw:overflow-hidden'>
			<div className='tw:px-4 tw:py-3.5 tw:border-b tw:border-border tw:flex tw:items-start tw:justify-between tw:gap-3'>
				<div>
					<div className='tw:text-[11px] tw:font-semibold tw:uppercase tw:tracking-[0.06em] tw:text-ink-3'>
						Día seleccionado
					</div>
					<div className='tw:mt-1 tw:text-[22px] tw:font-bold tw:text-ink-0'>
						{day ? moment.utc(day).format('D [de] MMMM') : '—'}
					</div>
					<div className='tw:mt-0.5 tw:text-[12.5px] tw:text-ink-3'>
						{events && events.length > 0
							? `${events.length} evento${events.length !== 1 ? 's' : ''}`
							: 'Sin actividad programada'}
					</div>
				</div>
				{googleConnected && day && (
					<Button size='sm' onClick={() => onAddEvent(day)}>Agregar</Button>
				)}
			</div>
			<div className='tw:px-4 tw:py-3 tw:flex-1 tw:overflow-y-auto tw:max-h-[480px] tw:flex tw:flex-col tw:gap-3.5'>
				{categories.map((cat) => (
					<div key={cat.category} className='tw:bg-surface tw:border tw:border-border tw:rounded-token tw:p-2 tw:flex tw:flex-col tw:gap-2'>
						<div className='tw:flex tw:items-center tw:gap-2.5'>
							<span className={classnames('tw:w-[3px] tw:h-3.5 tw:rounded-[2px]', cat.className)} />
							<span className='tw:flex-1 tw:text-[11.5px] tw:font-semibold tw:uppercase tw:tracking-[0.04em] tw:text-ink-1'>
								{cat.label}
							</span>
							<span className='tw:text-[11px] tw:text-ink-3 tw:bg-surface-2 tw:px-1.5 tw:rounded-token'>
								{cat.count}
							</span>
						</div>
						{cat.events.map((event, index) => (
							<div
								key={event.id || index}
								onClick={() => handleEventClick(event)}
								className={classnames(
									'tw:py-1.5 tw:cursor-pointer',
									index < cat.events.length - 1 && 'tw:border-b tw:border-border',
								)}
							>
								<CalendarEventRow
									event={event}
									onEditGoogleEvent={onEditGoogleEvent}
									onDeleteGoogleEvent={onDeleteGoogleEvent}
									onEditAppEvent={onEditAppEvent}
								/>
							</div>
						))}
					</div>
				))}
			</div>
		</section>
	);
}

export default CalendarDetailPanel;
